module.exports = __webpack_public_path__ + "static/img/ad-in-front.f80e5a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ad-in-front.png
// module id = KgKM
// module chunks = 1